import { BehaviorParameters } from 'rangeConfig/@types';
import { ErrorMessages, ProductType } from '@inter-ikea-storageone/range';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';
import { HierarchyUtils } from '@inter-ikea-core/core';
import {
  addTopPanelsToFrameGroup,
  frameHasTopPanelDesign,
  getAllFrameGroupsForTops,
  getPositionOfEntityTop
} from '../utils/topPanels';

const autoFillTopPanels = ({
  coreApi,
  props,
  rootState: {
    products: { inMarket: products }
  }
}: BehaviorParameters) => {
  if (!hideNoFramesInSceneErrorMessage(coreApi)) {
    coreApi.emit.onPlacementAttempt(ErrorMessages.NoFramesInScene);
  }

  const productId = props.coreProductIds?.length ? props.coreProductIds[0] : props.coreProductId;
  const topDesign = products.find(p => p.coreProductId === productId)?.design;
  if (!topDesign) {
    return;
  }

  // Add tops to TV-benches in scene
  const tvBenchesInScene = coreApi.entities.getByProductTypes([ProductType.BESTA_TV_BENCH]);
  tvBenchesInScene.forEach(bench => {
    const topForTvBench = products.find(
      p =>
        p.type === ProductType.BESTA_TOP_PANEL_TV_BENCH &&
        p.design === topDesign &&
        p.communicatedDimensions.width === coreApi.entities.getEntityComSize(bench)?.width
    );
    if (topForTvBench) {
      const currentTop = HierarchyUtils.descendants(bench).find(child =>
        coreApi.entities.isProductType(child, ProductType.BESTA_TOP_PANEL_TV_BENCH)
      );
      currentTop && coreApi.entities.delete(currentTop);
      coreApi.products.addToTarget(topForTvBench.coreProductId, bench);
    }
  });

  // Add tops to regular frames in scene (below 150cm)
  const frameGroups = getAllFrameGroupsForTops(coreApi);
  const framesAbove150 = coreApi.entities
    .getByProductTypes([ProductType.BESTA_FRAME_600_ASM, ProductType.BESTA_FRAME_1200_ASM])
    .filter(frame => getPositionOfEntityTop(frame, coreApi) >= 1500)
    .filter(frame => (coreApi.entities.getEntityComSize(frame)?.depth || 0) > 200);

  const topPanelsRegularFrames = products.filter(
    p => p.type === ProductType.BESTA_TOP_PANEL && p.design === topDesign
  );
  frameGroups.forEach(group => {
    addTopPanelsToFrameGroup(group, topPanelsRegularFrames, coreApi);
  });
  const allFrames = [...tvBenchesInScene, ...frameGroups.flatMap(group => group)];
  if (allFrames.some(frame => !frameHasTopPanelDesign(frame, topDesign, coreApi))) {
    // If not possible to place tops on all frames below 150cm show info toast
    coreApi.emit.onPlacementAttempt(ErrorMessages.BestaTopPanelsNotAddedToSomeFramesMessage);
  } else if (framesAbove150.length > 0) {
    // If having frames above 150cm show info toast
    coreApi.emit.onPlacementAttempt(ErrorMessages.BestaTopPanelsAbove150Message);
  }
};

export default autoFillTopPanels;
